<template>
    <div
        id="v-categories"
        class="c-categories-filter"
        v-if="isCreated"
        v-cloak
        ref="root"
    >
        <div v-if="selectedCategoryId" class="c-categories-filter__back">
            <button
                class="c-btn c-btn--categories-back"
                v-if="showBackButton"
                @click.prevent="back"
                :title="backButtonName"
            >
                <i class="ico ico-caret-left-thick is-on-left"></i>&nbsp;{{ backButtonName }}
            </button>
        </div>

        <div class="c-categories-filter__list">
            <a
                v-for="category in categories"
                v-bind:key="category.id"
                :href="category.link"
                :title="category.name"
                :class="{
                    'c-link': true,
                    'is-active': category.id == selectedCategoryId,
                }"
                @click.prevent="change(category.id)"
            >
                <div class="is-image">
                    <img class="c-img" :src="projectThumbnail(category.image, 'ret-subcat')" :alt="category.name" />
                </div>

                <span class="is-name">
                    {{ category.name }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import CategoriesFilter from './../../../../vendor/rshop/frontend/assets/js/components/CategoriesFilter';
import { thumbnail as projectThumb } from '../../functions/thumbnail';

export default {
    name: 'CategoriesFilter',
    extends: CategoriesFilter,
    methods: {
        projectThumbnail(src, format) {
            return projectThumb(src, format);
        }
    },
    computed: {
        backButtonName() {
            if (!this.selectedCategory) {
                return '';
            }

            if (this.actualView == 'siblings' && this.parent) {
                return this.parent.name;
            }

            return this.selectedCategory.name;
        },
    },
};
</script>